import React from "react";
import { Link } from "react-router-dom";
import "./Home.css"; // You'll need to create this CSS file
import Footer from "./Footer";

const Home = () => {
  return (
    <div className="home-container">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="welcome-badge">Welcome to New Pitman Shorthand Institute Prayagraj</div>
        <div className="home-hero-content">
          <h1>Master the Art of Professional Shorthand Writing</h1>
          <p className="hero-subtitle">
            Join India's leading institute for shorthand mastery. Enhance your
            career prospects with professional certification courses designed for
            success.
          </p>
          <div className="cta-buttons">
            <Link to="/courses" className="btn btn-primary">
              Explore Courses
            </Link>
            <Link to="/about" className="btn bsection">
              Learn More
            </Link>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="features-section">
        <h2>Why Practice With Us?</h2>
        <div className="features-grid">
          <div className="feature-card">
            <div className="feature-icon">⚡</div>
            <h3>Improve Speed</h3>
            <p>Track your WPM and set new personal records with our timed exercises</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">🎯</div>
            <h3>Enhance Accuracy</h3>
            <p>Real-time feedback helps you identify and correct mistakes</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">📊</div>
            <h3>Track Progress</h3>
            <p>Detailed statistics and progress tracking to monitor your improvement</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">🏆</div>
            <h3>Compete & Compare</h3>
            <p>Challenge friends and compare scores on our leaderboards</p>
          </div>
        </div>
      </section>

      {/* How It Works Section */}
      <section className="how-it-works-section">
        <h2>How It Works</h2>
        <div className="steps-container">
          <div className="step">
            <div className="step-number">1</div>
            <h3>Choose Your Level</h3>
            <p>Select from beginner, intermediate, or advanced exercises</p>
          </div>
          <div className="step">
            <div className="step-number">2</div>
            <h3>Practice Regularly</h3>
            <p>Consistent practice with our curated exercises</p>
          </div>
          <div className="step">
            <div className="step-number">3</div>
            <h3>Review Performance</h3>
            <p>Analyze your results and focus on improvement areas</p>
          </div>
          <div className="step">
            <div className="step-number">4</div>
            <h3>Master Stenography</h3>
            <p>Become proficient and increase your professional opportunities</p>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="testimonials-section">
        <h2>What Our Users Say</h2>
        <div className="testimonials-container">
          <div className="testimonial-card">
            <p>"This platform helped me increase my stenography speed by 40% in just two months!"</p>
            <div className="testimonial-author">- Sarah J., Court Reporter</div>
          </div>
          <div className="testimonial-card">
            <p>"The practice exercises are well-designed and the feedback is incredibly helpful."</p>
            <div className="testimonial-author">- Michael T., Stenography Student</div>
          </div>
          <div className="testimonial-card">
            <p>"I use this site daily to maintain my skills. The variety of exercises keeps it interesting."</p>
            <div className="testimonial-author">- Lisa R., Professional Stenographer</div>
          </div>
        </div>
      </section>

      {/* Call to Action Section */}
      <section className="cta-section">
        <h2>Ready to Improve Your Stenography Skills?</h2>
        <p>Join thousands of users who have enhanced their stenography abilities with our platform</p>
        <Link to="/login" className="btn btn-large">
          Get Started Now
        </Link>
      </section>

      {/* Footer With links */}
      <Footer />
    </div>
  );
};

export default Home;
